module.exports = __webpack_public_path__ + "static/media/minutes_played.d075038b.svg";